import { render, staticRenderFns } from "./PosDashboard.vue?vue&type=template&id=1bc1f8db&scoped=true&"
import script from "./PosDashboard.vue?vue&type=script&lang=js&"
export * from "./PosDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PosDashboard.vue?vue&type=style&index=0&id=1bc1f8db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1f8db",
  null
  
)

export default component.exports